
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.55 21.002c.4.8.5.8-.2 1.6-.4.6-.4 1.5-.2 2.2.1.4.5 1.1.9.6.9-1.2 1.4-2.7 1.3-4.3-.1-.7-.2-1.3-.5-1.8-.2-.5-.8-1-.5-1.4.6-.7.1-3.7-.7-2.7-.9 1.1-1 2.7-.8 4 .2.6.4 1.2.7 1.8zM30.85 21.002v-.1c.1 0 0 0 0 .1z"}}),_c('path',{attrs:{"d":"M29.75 22.902v.1c-.4.6-.4 1.5-.2 2.1.1.4.5 1.2.9.6.6-.9.9-1.9.8-2.9 0-.5-.1-1-.3-1.5 0-.1-.1-.2-.2-.3 0 .1-.1.2-.2.4.1-.1.1-.3.2-.4 0 0 0-.1-.1-.1-.2-.3.2-.4.1 0 .2-.5.1-1.1 0-1.6-.1-.4-.5-1.1-.9-.6-.6.8-.7 2-.6 3 .2.4.3.8.5 1.2zm.2.5c.1.1 0 .1 0 0 0 .1 0 .1 0 0zM49.25 31.402c-.4-2.2-1.7-4.3-4.2-4.3-1.3 0-2.3.6-3.1 1.5v-.9c0-.4-.1-1.6-.7-1.6h-28.3c-.6 0-.7 1.2-.7 1.6 0 5.2.1 11.1 5.7 13.4h-7.2c-1 0-1 3.2 0 3.2h7.7c.1.5.3.8.7.8h15.8c.3 0 .5-.4.6-.8h7.7c1 0 1-3.2 0-3.2h-7.4c3-1.1 4.5-3.4 5.2-6.3.6 1.4 1.8 2.5 3.5 2.6 2.7.1 4-2.1 4.4-4.4.1-.3.1-.6.1-.8.3-.1.3-.5.2-.8zm-16.2 7.2c-3.5 0-7 .1-10.6 0-5-.1-7.3-2.5-8.2-6.1h13.8c.7 0 .7-2.2 0-2.2h-14.2c0-.3-.1-.7-.1-1h26.8c0 .3 0 .7-.1 1h-6.2c-.7 0-.7 2.2 0 2.2h5.9c-.8 3.3-2.7 5.8-7.1 6.1zm12-4.3c-1 0-2.9-.8-2.9-2s1.8-2 2.7-2c1.1-.1 3 .7 3.1 2-.1 1.2-1.8 2-2.9 2z"}})])
          )
        }
      }
    